import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import PortfolioCarousel from "../components/site/PortfolioCarousel";
import Courses from "../components/site/Courses";
import About from "../components/site/About";
import Testimonials from "../components/site/Testimonials";
import Contact from "../components/site/Contact";
import Collaborations from "../components/site/Collaborations";
import AvailableDates from "../components/site/AvailableDates";
import Footer from "../components/site/Footer";
import BookingDialog from "../components/site/BookingDialog";
import { useLang } from "../contexts/LanguageContext";

const SEO = {
  es: {
    title: "Abril Suarez · Maquillista Profesional en Aguascalientes | Novias, Editorial & Cursos",
    desc: "Maquillista profesional en Aguascalientes especializada en novias, editorial y eventos de belleza. Reserva en línea y cursos de maquillaje. Servicio en todo México.",
  },
  en: {
    title: "Abril Suarez · Professional Makeup Artist in Aguascalientes | Bridal, Editorial & Courses",
    desc: "Professional makeup artist in Aguascalientes, Mexico — bridal, editorial and beauty events. Online booking and makeup courses available.",
  },
  jp: {
    title: "アブリル・スアレス · アグアスカリエンテスのプロメイクアップアーティスト | ブライダル・エディトリアル・講座",
    desc: "メキシコ・アグアスカリエンテスを拠点とするプロのメイクアップアーティスト。ブライダル、エディトリアル、ビューティイベント、メイク講座。オンライン予約受付中。",
  },
};

export default function Home() {
  const { lang } = useLang();
  const [bookingOpen, setBookingOpen] = useState(false);
  const [defaultService, setDefaultService] = useState(null);
  const [courseId, setCourseId] = useState(null);

  const openBooking = (service = null) => {
    setDefaultService(typeof service === "string" ? service : null);
    setCourseId(null);
    setBookingOpen(true);
  };

  const enrollCourse = (course) => {
    setDefaultService("course");
    setCourseId(course.id);
    setBookingOpen(true);
  };

  const seo = SEO[lang] || SEO.es;

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.desc} />
        <meta name="keywords" content="maquillista Aguascalientes, makeup artist Aguascalientes, maquillaje novias, maquillaje editorial, cursos de maquillaje, Abril Suarez, maquillaje XV años, maquillaje eventos" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.desc} />
        <meta property="og:image" content="https://images.pexels.com/photos/33976561/pexels-photo-33976561.jpeg" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="/" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BeautySalon",
          name: "Abril Suarez Makeup Artist",
          description: seo.desc,
          image: "https://images.pexels.com/photos/33976561/pexels-photo-33976561.jpeg",
          address: { "@type": "PostalAddress", addressLocality: "Aguascalientes", addressCountry: "MX" },
          areaServed: "Aguascalientes, México",
          sameAs: ["https://www.instagram.com/abrilsuamkp/"],
        })}</script>
      </Helmet>

      <Header onBook={() => openBooking()} />
      <main>
        <Hero onBook={() => openBooking()} />
        <Services onBook={(slug) => openBooking(slug)} />
        <PortfolioCarousel />
        <Testimonials />
        <Courses onEnroll={enrollCourse} />
        <About onBook={() => openBooking()} />
        <AvailableDates />
        <Collaborations />
        <Contact />
      </main>
      <Footer />

      <BookingDialog
        open={bookingOpen}
        onClose={() => setBookingOpen(false)}
        defaultService={defaultService}
        courseId={courseId}
      />
    </>
  );
}
